var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("barcodes")))]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        [
                          _c("app-custom-lang-select", {
                            model: {
                              value: _vm.selectedLang,
                              callback: function ($$v) {
                                _vm.selectedLang = $$v
                              },
                              expression: "selectedLang",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-scroll-view",
                { attrs: { tag: "w-list" } },
                [
                  _vm._l(_vm.layout.Barcodes, function (barcode, i) {
                    return _c(
                      "w-list-item",
                      { key: barcode.uuid },
                      [
                        _c("w-list-item-text", [
                          _vm._v(
                            " " +
                              _vm._s(barcode.getText(_vm.selectedLang)) +
                              " "
                          ),
                        ]),
                        _c(
                          "w-list-item-action",
                          [
                            _c(
                              "w-button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$ct("tooltip.edit-barcode"),
                                    expression: "$ct('tooltip.edit-barcode')",
                                  },
                                ],
                                attrs: { icon: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editBarcode(i)
                                  },
                                },
                              },
                              [_c("w-fa", { attrs: { icon: "pen" } })],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "w-list-item-action",
                          [
                            _c(
                              "w-button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$ct("tooltip.remove-barcode"),
                                    expression: "$ct('tooltip.remove-barcode')",
                                  },
                                ],
                                staticClass: "danger",
                                attrs: { icon: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeBarcode(i)
                                  },
                                },
                              },
                              [_c("w-fa", { attrs: { icon: "times" } })],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _c(
                    "w-list-item",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.addNewBarcode()
                        },
                      },
                    },
                    [
                      _c(
                        "w-list-item-icon",
                        [_c("w-fa", { attrs: { icon: "plus" } })],
                        1
                      ),
                      _c("w-list-item-text", [
                        _vm._v(_vm._s(_vm.$ct("tooltip.add-barcode"))),
                      ]),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEditBarcode != null } },
        [
          _vm.toEditBarcode
            ? _c("app-barcode-settings-edit-modal", {
                attrs: {
                  lang: _vm.selectedLang,
                  value: _vm.toEditBarcode,
                  layout: _vm.layout,
                },
                on: {
                  input: function ($event) {
                    return _vm.saveBarcode($event)
                  },
                  close: function ($event) {
                    return _vm.closeBarcodeEdit()
                  },
                  lang: function ($event) {
                    _vm.selectedLang = $event
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }